
import { DataTableSchema, DefaultTableSchema, TITLE_TYPE } from './dynamic-data-table.model';
import { DashboardContainerComponent } from '../layout/dashboard-container/dashboard-container.component';
import { AxisType, BarChartModel, CHART_TYPE, ColumnChartModel, CommonChartModel, PieChartModel } from './chart.model';
import { TabConfig, SECTION_TYPE, dynamicComponentSchema, DynamicFormArray, FormFieldConfig, Props } from './form.model';
import { AreaRegionDropdown, CalendarYearDropdown, FieldNames, FiscalYearDropdown, MonthDropdown, PeriodDropdown, TotalAmountText, TotalCountText } from './form-fields.model';
import { DYNAMIC_IDENTIFIER } from './common.model';
import { DealerBillingManageExceptionReportComponent } from '../components/dealer-billing-manage-exception-report/dealer-billing-manage-exception-report.component';
import { ChartComponent } from '../layout/chart/chart.component';
import { environment } from '../../../environments/environment';
import { ApiEnvNames, FETCH_METHODS, SearchConfig } from './api.model';
import { DealerTrainingBillingReportComponent } from '../components/dealer-training-billing-report/dealer-training-billing-report.component';
import { FormContainerComponent } from '../layout/form/form-container/form-container.component';
import { FilterListContainerComponent } from '../layout/filter-list-container/filter-list-container.component';

export const DealerTrainingBillingTitle = "Course Billing";

export const CourseName="Course Name";
export const DealerCode ="Dealer Code";
export const DealerName ="Dealer Name";
export const DealerArea ="Dealer Area";
export const DealerDistrict ="Dealer District";


export const DealerTrainingBillingBaseUrl = () => {
    return environment['dealerTrainingBilling'];
};
const FormFieldArray: FormFieldConfig[] = structuredClone([MonthDropdown]);


export const DealerDashboardReportProps: Props = {
    istitleCenter: true,
}

export const SectionNames = {
    RollingMonths: 'billingAmountPerYear',
    AreaBillingYear: 'billingTrendPerYear',
    AreaBillingMonth: 'billingTrendPerMonth',
    BillingTrendsDealer: 'billingTrendsDealer',
    BillingTrendCourses: 'billingTrendCourses',
    AttendenceCountDealersYear: 'attendenceCountDealersYear',
    AttendenceCountCoursesYear: 'attendenceCountCoursesYear',
    AttendenceCountDealers: 'attendenceCountDealers',
    DealerTrainingBillingReport: 'dealerTrainingBillingReport',
    DealerTrainingBillingDashboardReport: 'dealerTrainingBillingDashboardReport',
    DealerTrainingBillingManagePayment: 'dealerTrainingBillingManagePayment'
} as const;
export type FetchMethod = typeof SectionNames[keyof typeof SectionNames];

export const DealerBillingDashboardCommonPayload = {
    "year": "",
    "yearType": ""
}

export const FetchConfig: Record<FetchMethod, SearchConfig> = {
    [SectionNames['RollingMonths']]: {
        path: 'billingAmountPerYear',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['DealerTrainingBilling']
    },
    [SectionNames['AreaBillingYear']]: {
        path: 'billingTrendPerYear',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['DealerTrainingBilling']

    },
    [SectionNames['AreaBillingMonth']]: {
        path: 'billingTrendPerMonth',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['DealerTrainingBilling']
    },
    [SectionNames['BillingTrendsDealer']]: {
        path: 'dealerTrendPerMonth',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['DealerTrainingBilling']
    },
    [SectionNames['BillingTrendCourses']]: {
        path: 'courseTrendPerMonth',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['DealerTrainingBilling']
    },
    [SectionNames['AttendenceCountDealersYear']]: {
        path: 'dealerAttendancePerMonth',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['DealerTrainingBilling']
    },
    [SectionNames['AttendenceCountCoursesYear']]: {
        path: 'courseAttendancePerMonth',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['DealerTrainingBilling']
    },
    [SectionNames['AttendenceCountDealers']]: {
        path: 'overallAttendanceCount',
        method: FETCH_METHODS['Get'],
        body:{
            [FieldNames['Month']]:'',
            [FieldNames['Period']]:'',
            [FieldNames['Area']]:''
        },
        urlPath: ApiEnvNames['DealerTrainingBilling']
    },
    [SectionNames['DealerTrainingBillingDashboardReport']]: {
        path: 'overallCourseAttendance',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['DealerTrainingBilling']
    },
    [SectionNames['DealerTrainingBillingReport']]: {
        path: 'overallCourseAttendance',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['DealerTrainingBilling']
    },

    [SectionNames['DealerTrainingBillingManagePayment']]: {
        path: 'dealerTrainingBillingManagePayment',
        method: FETCH_METHODS['Post'],
        urlPath: ApiEnvNames['DealerTrainingBilling']
    }
}

export const DealerTrainingTabIds = {
    Dashboard: 'dashboard',
    Report: 'report',
    ManageExceptionReport: 'manageExceptionReport'
}

export const DealerTrainingBillingDashboardReport: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    titleSchema: {
        [FieldNames['Month']]: {
            label: '',
            title: `${DYNAMIC_IDENTIFIER['selectedField']} - ${DYNAMIC_IDENTIFIER['globalyear']}  Summary`,
            type: TITLE_TYPE['Dynamic']
        }
    },
    columnSchema: [
        { label: 'COURSE', fieldKey: 'title', isNotCamelCase: true },
        { label: 'TOTAL HELD', fieldKey: 'sessions' },
        { label: 'TOTAL ATTENDEES', fieldKey: 'attendees' },
        { label: 'RECOVERIES($)', fieldKey: 'amount', isCurrency: true }
    ],
    isFooterRequired: true,
    isTableGap: true,
    columnSigns: {
        labelColumnText: 'amount',
    },
    footerConfig: {
        labelColumnText: 'Total',
        fields:['amount','attendees','sessions']
    },
    isExportRequired: false,
    isFilterListExportRequired:true,
    exportConfig: {
        fileName: 'Course_Summary',
        schema: {
            title: "Course",
            [DYNAMIC_IDENTIFIER['selectedField']]: [FieldNames['Month']],
            sessions: "Total Held",
            attendees: "Total ATTENDEES",
            amount: "RECOVERIES($)",
        },
        footer:{
            sum:[{fieldKey:'title',label:'TOTAL'},{fieldKey:'',label:''},{fieldKey:'sessions',sumBy:'sessions'},{fieldKey:'attendees',sumBy:'attendees'},{fieldKey:'amount',sumBy:'amount'}]
        },
        exportMessage: "Course Summary"
    },
    isSearchRequired: false,
    pageSizeOptions:{
        pageSize: [15, 25, 50, 100]
    },
    isPaginationRequired: true
}

export const RollingColumnChart: CommonChartModel = {
    ...structuredClone(ColumnChartModel),
    dataSchema: {
        label: 'month',
        value: 'amount',
        drillDownConfig: {
            xAxis: {
                title: 'Weeks'
            },
            titleSchema: {
                label: '',
                subLabel: "",
                title: `Rolling ${DYNAMIC_IDENTIFIER['drilldownField']} month billing amounts per week`,
                subTitle: `${DYNAMIC_IDENTIFIER['globalyear']}`,
                type: TITLE_TYPE['Dynamic']
            },
            drillDownField: 'weeklyDetails',
            type: CHART_TYPE['ColumnChart'],
            label: 'weekNumber',
            value: 'amount',
            dataLabels: {
                enabled: true,
                format:  `$` + "{point.y}"
            },
            tooltip: {
                headerFormat: `<span style="font-size:11px">{point.primaryData.month}</span><br>`,
                pointFormat: `
                <span style="color:{point.color}">{point.name}</span>: <b>$ {point.y}</b><br/>`
            }
        }
    },
    titleSchema: {
        label: '',
        subLabel: "",
        title: 'Rolling 12 months billing per month',
        subTitle: `${DYNAMIC_IDENTIFIER['globalyear']}`,
        type: TITLE_TYPE['Dynamic']
    },
    tooltip: {
        headerFormat: `<span style="font-size:11px">Monthly Amount</span><br>`,
        pointFormat: `<span style="color:{point.color}">{point.name}</span>: <b>$ {point.y}<br/>`
    },
    xAxis: {
        type: AxisType['Category'],
        title: {
            text: 'Month',
        }
    },
    yAxis: {
        title: {
            text: 'Cost ($)',
        }
    },
    series: [{
        color: '#7ab1e7',
        data: [],
        dataLabels: {
            enabled: true,
            format: `$` + "{point.y}"
        },
    }],
}

export const AreaBillingYearChart: CommonChartModel = {
    ...structuredClone(PieChartModel),
    tooltip: {
        headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
        pointFormat: `<span>Amount</span>: <b>$ {point.y}</b><br/>`
    },
    dataSchema: {
        label: 'areaName',
        value: 'totalAmount',
        drillDownConfig: {
            xAxis: {
                title: 'Dealers'
            },
            yAxis: {
                title: 'Cost ($)'
            },
            drillDownField: "dealerDetails",
            label: "dealer",
            value: "amount",
            type: CHART_TYPE['BarChart'],
            tooltip: {
                headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
                pointFormat: `
                <span>Dealer Name</span>: <b>{point.dataset.dealerName}</b><br/>
                <span>Area</span>: <b>{point.dataset.area}</b><br/>
                <span>District</span>: <b>{point.dataset.district}</b><br/>
                <span>Amount</span>: <b>$ {point.dataset.amount}</b><br/>`
            },
            titleSchema: {
                title: `Billing trends of ${DYNAMIC_IDENTIFIER['drilldownField']} for ${DYNAMIC_IDENTIFIER['globalyear']}`,
                subTitle: ``,
                type: TITLE_TYPE['Dynamic']
            },
        }
    },
    titleSchema: {
        label: '',
        title: `Area billing trend for ${DYNAMIC_IDENTIFIER['globalyear']}`,
        type: TITLE_TYPE['Dynamic']
    },
    xAxis: {
        type: AxisType['Category'],
        title: {
            text: 'Dealer',
        }
    },
    dataLabels: {
        enabled: true,
        format: "{point.name}: " + `$` + "{point.y}"
    }
}

export const AreaBillingMonthChart: CommonChartModel = {
    ...structuredClone(PieChartModel),
    tooltip: {
        headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
        pointFormat: `<span>Amount</span>: <b>$ {point.y}</b><br/>`
    },
    dataSchema: {
        label: 'areaName',
        value: 'totalAmount',
        drillDownConfig: {
            xAxis: {
                title: 'Dealers'
            },            
            yAxis: {
                title: 'Cost ($)'
            },
            drillDownField: "dealerDetails",
            label: "dealer",
            value: "amount",
            type: CHART_TYPE['BarChart'],
            tooltip: {
                headerFormat: `<span style="font-size:11px"><b>{point.name}</b></span><br>`,
                pointFormat: `
                <span>Dealer Name</span>: <b>{point.dataset.dealerName}</b><br/>
                <span>Area</span>: <b>{point.dataset.area}</b><br/>
                <span>District</span>: <b>{point.dataset.district}</b><br/>
                <span>Amount</span>: <b>$ {point.dataset.amount}</b><br/>`
            },
            titleSchema: {
                [FieldNames['Month']]: {
                    label: '',
                    title: `Billing trend for ${DYNAMIC_IDENTIFIER['drilldownField']} for ${DYNAMIC_IDENTIFIER['selectedField']} ${DYNAMIC_IDENTIFIER['globalyear']}`,
                    type: TITLE_TYPE['Dynamic']
                }
            },
        }
    },
    titleSchema: {
        [FieldNames['Month']]: {
            label: '',
            title: `Area billing trend for ${DYNAMIC_IDENTIFIER['selectedField']} ${DYNAMIC_IDENTIFIER['globalyear']}`,
            type: TITLE_TYPE['Dynamic']
        }
    },
    xAxis: {
        type: AxisType['Category'],
        title: {
            text: 'Dealers',
        }
    },
    dataLabels: {
        enabled: true,
        format: "{point.name}: " + `$` + "{point.y}"
    }
}

export const BillingTrendsDealerChart: CommonChartModel = {
    ...structuredClone(BarChartModel),
    tooltip: {
        pointFormat: `
        <br/>
        <span>Dealer Name</span>: <b><span>{point.dataset.dealerName}</span></b><br/>
        <span>Area</span><span>: <b>{point.dataset.areaName}</b></span><br/>
        <span>District</span>: <b><span>{point.dataset.district}</span></b><br/>
        <span>Amount</span>: <b><span>$</span>{point.dataset.amount}</b><br/>`
    },
    dataSchema: {
        label: 'dealer',
        value: 'amount',
    },
    titleSchema: {
        [FieldNames['Month']]: {
            label: '',
            subLabel: '',
            title: 'Billing Trend across Dealers',
            subTitle: `For ${DYNAMIC_IDENTIFIER['selectedField']} ${DYNAMIC_IDENTIFIER['globalyear']}`,
            type: TITLE_TYPE['Dynamic']
        }
    },
    xAxis: {
        labels: {
            style: {
                fontSize: '8px',
            },
        },
        title: {
            text: 'Dealers',
        }
    },
    yAxis: {
        title: {
            text: 'Cost ($)',
        }
    }
}

export const BillingTrendsCoursesChart: CommonChartModel = {
    ...structuredClone(BarChartModel),
    tooltip: {
        pointFormat: `
        <span>${CourseName}</span><span>: <b>{point.dataset.title}</b></span><br/>
        <span>Amount</span>: <b><span>$</span>{point.dataset.amount}</b><br/>`
    },
    dataSchema: {
        label: 'course',
        value: 'amount'
    },
    titleSchema: {
        [FieldNames['Month']]: {
            label: '',
            subLabel: '',
            title: 'Billing trend across Courses',
            subTitle: `For ${DYNAMIC_IDENTIFIER['selectedField']} ${DYNAMIC_IDENTIFIER['globalyear']}`,
            type: TITLE_TYPE['Dynamic']
        }
    },
    xAxis: {
        title: {
            text: 'Courses',
        }
    },
    yAxis: {
        title: {
            text: 'Cost ($)',
        }
    },
    series: [{
        name: '',
        type: 'bar',
        color: '#7ab1e7',
        data: [],
        dataLabels: {
            enabled: true,
            format: `$ {point.y:.0f}`,
            align: 'right',
            inside: false,
            style: {
                fontSize: '0.7em',
                color: 'black',
                fontWeight: '500',
                textDecoration: 'none',
            },
            x: 50,
            y: -7,
        },
    },]
}

export const AttendenceCountDealersYearChart: CommonChartModel = {
    ...structuredClone(PieChartModel),
    tooltip: {
        headerFormat: '<span style="font-size:11px"><b>{point.name} Count</b></span><br>',
        pointFormat: `<b><span>{point.y}</span></b><br/>`
    },
    dataSchema: {
        label: 'status',
        value: 'totalCount',
        drillDownConfig: {
            xAxis: {
                title: 'Dealers'
            },
            yAxis:{
                title:'Count'
            },
            drillDownField: 'dealerDetails',
            type: CHART_TYPE['ColumnChart'],
            label: 'dealer',
            value: 'count',
            tooltip: {
                headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
                pointFormat: `
                <span>Dealer Name</span>: <b>{point.dataset.dealerName}</b><br/>
                <span>Area</span>: <b>{point.dataset.area}</b><br/>
                <span>District</span>: <b>{point.dataset.district}</b><br/>
                <span>Count</span>: <b>{point.dataset.count}</b><br/>`
            },
            titleSchema: {
                [FieldNames['Month']]: {
                    label: '',
                    title: `${DYNAMIC_IDENTIFIER['drilldownField']} Count by Dealer for ${DYNAMIC_IDENTIFIER['selectedField']} ${DYNAMIC_IDENTIFIER['globalyear']}`,
                    type: TITLE_TYPE['Dynamic'],
                    subTitle: ""
                },
                [FieldNames['Period']]: {
                    label: '',
                    subLabel: '',
                    title: `${DYNAMIC_IDENTIFIER['drilldownField']} Count by Dealer for last ${DYNAMIC_IDENTIFIER['selectedField']}`,
                    subTitle: DYNAMIC_IDENTIFIER['period'],
                    type: TITLE_TYPE['Dynamic']
                }
            }
        }
    },
    titleSchema: {
        [FieldNames['Month']]: {
            label: '',
            title: `Attendance count across Dealer for ${DYNAMIC_IDENTIFIER['selectedField']} ${DYNAMIC_IDENTIFIER['globalyear']}`,
            type: TITLE_TYPE['Dynamic']
        },
        [FieldNames['Period']]: {
            label: '',
            subLabel: '',
            title: `Attendance count across Dealer for last ${DYNAMIC_IDENTIFIER['selectedField']}`,
            subTitle: DYNAMIC_IDENTIFIER['period'],
            type: TITLE_TYPE['Dynamic']
        }
    },
    xAxis: {
        type: AxisType['Category'],
        title: {
            text: 'Dealer',
        }
    },
    yAxis: {
        title: {
            text: 'COUNT',
        }
    },
}

export const AttendenceCountCoursesYearChart: CommonChartModel = {
    ...structuredClone(PieChartModel),
    tooltip: {
        headerFormat: '<span style="font-size:11px">{point.name} Count</span><br>',
        pointFormat: `<b><span>{point.y}</span></b><br/>`
    },
    dataSchema: {
        label: 'status',
        value: 'totalCount',
        drillDownConfig: {
            xAxis: {
                title: 'Courses'
            },
            yAxis:{
                title:'Count'
            },
            drillDownField: 'courseDetails',
            type: CHART_TYPE['ColumnChart'],
            label: 'course',
            value: 'count',
            tooltip: {
                headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
                pointFormat: `
                <span>Course Title</span>: <b>{point.dataset.courseName}</b><br/>
                <span>Count</span>: <b>{point.dataset.count}</b><br/>`
            },
            titleSchema: {
                [FieldNames['Month']]: {
                    label: '',
                    title: `${DYNAMIC_IDENTIFIER['drilldownField']} Count by courses for ${DYNAMIC_IDENTIFIER['selectedField']}  ${DYNAMIC_IDENTIFIER['globalyear']}`,
                    type: TITLE_TYPE['Dynamic'],
                    subTitle: ""
                },
                [FieldNames['Period']]: {
                    label: '',
                    subLabel: '',
                    title: `${DYNAMIC_IDENTIFIER['drilldownField']} Count by courses for last ${DYNAMIC_IDENTIFIER['selectedField']}`,
                    subTitle: DYNAMIC_IDENTIFIER['period'],
                    type: TITLE_TYPE['Dynamic']
                }
            }
        }
    },
    titleSchema: {
        [FieldNames['Month']]: {
            label: '',
            title: `Attendance count across Courses for ${DYNAMIC_IDENTIFIER['selectedField']} ${DYNAMIC_IDENTIFIER['globalyear']}`,
            type: TITLE_TYPE['Dynamic']
        },
        [FieldNames['Period']]: {
            label: '',
            title: `Attendance count across Courses for last ${DYNAMIC_IDENTIFIER['selectedField']}`,
            subTitle: DYNAMIC_IDENTIFIER['period'],
            type: TITLE_TYPE['Dynamic']
        }
    },
    yAxis: {
        title: {
            text: 'COUNT',
        }
    },
}

export const AttendenceCountDealersChart: CommonChartModel = {
    ...structuredClone(BarChartModel),
    tooltip: {
        headerFormat: '<span style="font-size:11px"><b>{point.dataset.dealer}</b></span><br>',
        pointFormat: `
        <span>Dealer Name</span>: <b><span>{point.dataset.dealerName}</span></b><br/>
        <span>Dealer Area</span>: <b><span>{point.dataset.areaName}</span></b><br/>
        <span>Dealer District</span>: <b><span>{point.dataset.district}</span></b><br/>
        <span>Dealer Location</span>: <b><span>{point.dataset.accountAddress1}</span></b><br/>
        <span>{point.nameKey}</span>: <b><span>{point.y}</span></b><br/>
        `
    },
    legend: {
        enabled: true,
    },
    dataSchema: {
        label: 'dealer',
        value: ['noShowCount', 'completedCount'],
        tooltipLabelInfo: {
            'noShowCount': "No Show Count",
            'completedCount': "Completed Count"
        }
        
    },
    titleSchema: {
        [FieldNames['Month']]: {
            label: '',
            title: `Attendance count of each Dealer for ${DYNAMIC_IDENTIFIER['selectedField']} ${DYNAMIC_IDENTIFIER['globalyear']}`,
            type: TITLE_TYPE['Dynamic']
        },
        [FieldNames['Period']]: {
            label: '',
            title: `Attendance count of each Dealer for last ${DYNAMIC_IDENTIFIER['selectedField']}`,
            subTitle: DYNAMIC_IDENTIFIER['period'],
            type: TITLE_TYPE['Dynamic']
        }
    },
    subtitle: '2024',
    xAxis: {
        title: {
            text: 'Count',
        }
    },
    yAxis: {
        title: {
            text: 'No of People',
        }
    },
    plotOptions:{},
    series: [{
        name: 'Completed',
        type: CHART_TYPE['BarChart'],
        data: [],
        key: 'completedCount'
    },
    {
        name: 'No Show',
        type: CHART_TYPE['BarChart'],
        data: [],
        key: 'noShowCount'
    }]
}

export const DealerDashboardReportFormArray: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    title: 'May-2024 Summary'
    // title: `${DYNAMIC_IDENTIFIER['selectedField']} - ${DYNAMIC_IDENTIFIER['lastYear']}  Summary`,
}
export const DealerTrainingBillingGridSchema: Array<dynamicComponentSchema> = [
    {
        component: FormContainerComponent,
        type: SECTION_TYPE['GlobalFilter'],
        inputs: {
            dynamicFormArray: {
                formName: 'dealerBillingGlobalFilter',
                FieldsArray: structuredClone([
                    { ...CalendarYearDropdown, isDependentOn: FieldNames['FiscalYear'], showSelect:false },
                    { ...FiscalYearDropdown, isDependentOn: FieldNames['CalendarYear'] ,showSelect:false},
                ]),
                searchConfig: {
                    method: "POST",
                    path: "",
                    body: {
                        "year": "",
                        "yearType": ""
                    }
                }
            },
        },
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: RollingColumnChart,
            chartType: CHART_TYPE['ColumnChart'],
            elementId: SectionNames['RollingMonths'],
            apiConfig: FetchConfig[SectionNames['RollingMonths']],
            infoFields: structuredClone([{
                ...TotalAmountText, calculateBy: 'amount'
            }]),
            globalFilterFields: [FieldNames['FiscalYear'], FieldNames['CalendarYear']],
            onLoadFetch:false
        },
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: AreaBillingYearChart,
            chartType: CHART_TYPE['PieChart'],
            elementId: SectionNames['AreaBillingYear'],
            apiConfig: FetchConfig[SectionNames['AreaBillingYear']],
            exportConfig: {
                fileName: 'Area_Billing_Trend_Dealers',
                exportMessage: "Area Billing Trend Dealers Data",
                isCamelCase:['dealerName','area'],
                schema: {
                    dealer: DealerCode,
                    dealerName: DealerName,
                    area: DealerArea,
                    district: DealerDistrict,
                    amount: "Amount($)"

                }
            },
            infoFields: structuredClone([{
                ...TotalAmountText, calculateBy: 'totalAmount'
            }]),
            globalFilterFields: [FieldNames['FiscalYear'], FieldNames['CalendarYear']],
            onLoadFetch:false

        }
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: AreaBillingMonthChart,
            chartType: CHART_TYPE['PieChart'],
            elementId: SectionNames['AreaBillingMonth'],
            apiConfig: FetchConfig[SectionNames['AreaBillingMonth']],
            exportConfig: {
                fileName: 'Area_Billing_Trend_Dealers',
                exportMessage: "Area Billing Trend Dealers Data",
                isCamelCase:['dealerName','area'],
                schema: {
                    dealer: DealerCode,
                    dealerName: DealerName,
                    area: DealerArea,
                    district: DealerDistrict,
                    amount: "Amount($)",
                    [DYNAMIC_IDENTIFIER['selectedField']]: [FieldNames['Month']]
                }
            },
            filterSchema: {
                FieldsArray: structuredClone([{
                    ...MonthDropdown, required:true, multiple:true, payloadInfo: {
                        [FieldNames['Month']]: ''
                    }
                }])
            },
            infoFields: structuredClone([{
                ...TotalAmountText, calculateBy: 'totalAmount'
            }]),
            globalFilterFields: [FieldNames['CalendarYear']],
            onLoadFetch:false
        },

    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: BillingTrendsDealerChart,
            onLoadFetch:false,
            chartType: CHART_TYPE['BarChart'],
            elementId: SectionNames['BillingTrendsDealer'],
            apiConfig: FetchConfig[SectionNames['BillingTrendsDealer']],
            exportConfig: {
                fileName: 'Billing_Trend_Across_Dealers',
                exportMessage: "Billing Trend Across Dealers Data",
                isCamelCase:['dealerName','areaName'],
                schema: {
                    dealer: DealerCode,
                    dealerName: DealerName,
                    areaName: DealerArea,
                    district: DealerDistrict,
                    amount: "Amount($)",
                    [DYNAMIC_IDENTIFIER['selectedField']]: [FieldNames['Month']]
                }
            },
            filterSchema: {
                FieldsArray: structuredClone([{
                    ...MonthDropdown, required:true, multiple:true, payloadInfo: {
                        [FieldNames['Month']]: ''
                    }
                }])
            },
            infoFields: structuredClone([{
                ...TotalAmountText, calculateBy: "amount"
            }]),
            globalFilterFields: [FieldNames['CalendarYear']]
        },
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: BillingTrendsCoursesChart,
            onLoadFetch:false,
            chartType: CHART_TYPE['BarChart'],
            elementId: SectionNames['BillingTrendCourses'],
            apiConfig: FetchConfig[SectionNames['BillingTrendCourses']],
            exportConfig: {
                fileName: 'Billing_Trends_Courses',
                exportMessage: "Billing Trends Courses Data",
                schema: {
                    course: "COURSE ID",
                    title: CourseName,
                    amount: "Amount($)",
                    [DYNAMIC_IDENTIFIER['selectedField']]: [FieldNames['Month']]
                }
            },
            filterSchema: {
                FieldsArray: structuredClone([{
                    ...MonthDropdown, required:true, multiple:true, payloadInfo: {
                        [FieldNames['Month']]: ''
                    }
                }]),
            },
            infoFields: structuredClone([{
                ...TotalAmountText, calculateBy: 'amount'
            }]),
            globalFilterFields: [FieldNames['CalendarYear']]
        },
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: AttendenceCountDealersYearChart,
            onLoadFetch:false,
            chartType: CHART_TYPE['PieChart'],
            elementId: SectionNames['AttendenceCountDealersYear'],
            apiConfig: FetchConfig[SectionNames['AttendenceCountDealersYear']],
            exportConfig: {
                fileName: 'Attendance_Count_Dealers',                
                exportMessage: "Attendance Count Dealers Data",
                isCamelCase:['dealerName','area'],
                schema: {
                    dealer:"DEALER CODE",
                    dealerName:"DEALER NAME",
                    area: "AREA",
                    district:"DISTRICT",
                    status:"STATUS",
                    count: "COUNT",
                    [DYNAMIC_IDENTIFIER['selectedField']]: [FieldNames['Month'], FieldNames['Period']]
                }
            },
            filterSchema: {
                FieldsArray: structuredClone([
                    {
                        ...MonthDropdown,multiple:true, isDependentOn: FieldNames['Period'], payloadInfo: {
                            [FieldNames['Month']]: '',
                            'filterType': FieldNames['Month']
                        }
                    },
                    {
                        ...PeriodDropdown, isDependentOn: FieldNames['Month'], payloadInfo: {
                            [FieldNames['Period']]: '',
                            'filterType': FieldNames['Period']
                        }, showSelect: false
                    },]),
            },
            infoFields: structuredClone([{
                ...TotalCountText, calculateBy: 'totalCount'
            }]),
            globalFilterFields: [FieldNames['CalendarYear']]
        },
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: AttendenceCountCoursesYearChart,
            onLoadFetch:false,
            chartType: CHART_TYPE['PieChart'],
            elementId: SectionNames['AttendenceCountCoursesYear'],
            apiConfig: FetchConfig[SectionNames['AttendenceCountCoursesYear']],
            exportConfig: {
                fileName: 'Attendance_Count_Course',
                exportMessage: "Attendance Count Course Data",
                isCamelCase:['status'],
                schema: {
                    course:"COURSE ID",
                    courseName:CourseName,
                    status:"STATUS",
                    count: "COUNT",
                    [DYNAMIC_IDENTIFIER['selectedField']]: [FieldNames['Month'], FieldNames['Period']]
                }
            },
            filterSchema: {
                FieldsArray: structuredClone([
                    {
                        ...MonthDropdown,multiple:true, isDependentOn: FieldNames['Period'], payloadInfo: {
                            [FieldNames['Month']]: '',
                            'filterType': FieldNames['Month']
                        }
                    },
                    {
                        ...PeriodDropdown, isDependentOn: FieldNames['Month'], payloadInfo: {
                            [FieldNames['Period']]: '',
                            'filterType': FieldNames['Period']
                        }, showSelect: false
                    }]),
            },
            infoFields: structuredClone([{
                ...TotalCountText, calculateBy: 'totalCount'
            }]),
            globalFilterFields: [FieldNames['CalendarYear']]

        },
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: AttendenceCountDealersChart,
            onLoadFetch:false,
            chartType: CHART_TYPE['BarChart'],
            elementId: SectionNames['AttendenceCountDealers'],
            apiConfig: FetchConfig[SectionNames['AttendenceCountDealers']],
            exportConfig: {                
                fileName: 'Dealer_Attendance',
                exportMessage: "Dealer Attendance Data",
                isCamelCase:['dealerName','areaName','accountAddress1','accountCity'],
                schema: {
                    dealer: "DEALER CODE",
                    dealerName: "DEALER NAME",
                    areaName: "DEALER AREA",
                    district: "DEALER DISTRICT",
                    completedCount: "COMPLETED COUNT",
                    noShowCount: "NO SHOW COUNT",
                    accountAddress1: "DEALER ADDRESS",
                    accountCity: "DEALER CITY",
                    accountState: "DEALER STATE",
                    [DYNAMIC_IDENTIFIER['selectedField']]: [FieldNames['Month'], FieldNames['Period'], FieldNames['Area']]
                }
            },
            filterSchema: {
                FieldsArray: structuredClone([
                    {
                        ...MonthDropdown,multiple:true, isDependentOn: FieldNames['Period'], payloadInfo: {
                            [FieldNames['Month']]: '',
                            'filterType': FieldNames['Month']
                        }
                    },
                    {
                        ...PeriodDropdown, isDependentOn: FieldNames['Month'], payloadInfo: {
                            [FieldNames['Period']]: '',
                            'filterType': FieldNames['Period']
                        }, showSelect: false
                    },
                    AreaRegionDropdown
                ]),
            },
            infoFields: structuredClone([{
                ...TotalCountText, calculateBy: ['noShowCount', 'completedCount']
            }]),
            globalFilterFields: [FieldNames['CalendarYear']]

        }
    },
    {
        component: FilterListContainerComponent,
        type: SECTION_TYPE['List'],
        inputs: {
            elementId: SectionNames['DealerTrainingBillingDashboardReport'],
            DataTableSchema: DealerTrainingBillingDashboardReport,
            forSection: true,
            filterSchema: {
                FieldsArray: structuredClone([{...MonthDropdown, required:true, multiple:true}]),
            },
            apiConfig: FetchConfig[SectionNames['DealerTrainingBillingDashboardReport']],
            globalFilterFields: [FieldNames['CalendarYear']],
            onLoadFetch:false,
        }
    }
]

export const DealerTrainingBillingTabSchema: Array<TabConfig> = [{
    label: 'Charts',
    tabId: DealerTrainingTabIds['Dashboard'],
    type: SECTION_TYPE.Dashboard,
    component: DashboardContainerComponent,
    tabInfoText: "CSOD integration tag: CBL_Billing",
    inputs: {
        gridSchema: DealerTrainingBillingGridSchema
    }
}, {
    label: 'Reports',
    tabId: DealerTrainingTabIds['Report'],
    type: SECTION_TYPE.FilterWithTable,
    component: DealerTrainingBillingReportComponent,
    inputs: {}
}, {
    label: 'Manage Exception Report',
    tabId: DealerTrainingTabIds['ManageExceptionReport'],
    type: SECTION_TYPE.FilterWithTable,
    component: DealerBillingManageExceptionReportComponent,
    inputs: {}
}];

